"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Utility method to unify all the error message to certain type of error object
function getErrorMessage(errorObj) {
    if (!errorObj) {
        return { message: 'An unknown error occurred.' };
    }
    // An error from our API
    if ({}.hasOwnProperty.call(errorObj, 'error')) {
        var error = errorObj.error;
        return {
            statusCode: error.statusCode,
            message: error.message,
            code: error.code || 'InternalServerError',
        };
    }
    // If it's none of the above, it hasn't come across yet.
    console.warn('Unhandled error type! See utils/errors.js and add handling for this', JSON.stringify(errorObj));
    return errorObj;
}
exports.default = getErrorMessage;
